import { ReactElement, ReactNode } from 'react'
import styled from 'styled-components'

const getContainerSize = (big?: boolean, focused?: boolean): string => {
  if (big) {
    return focused ? '34px' : '28px'
  }
  return focused ? '28px' : '22px'
}

const Container = styled.div<{
  bgColor: string
  borderColor: string
  textColor: string
  big?: boolean
  focused?: boolean
}>`
  position: relative;
  background: ${({ bgColor }): string => bgColor};
  width: ${({ big, focused }): string => getContainerSize(big, focused)};
  height: ${({ big, focused }): string => getContainerSize(big, focused)};
  font-size: ${({ big }): string => (big ? '15px' : '14px')};
  color: ${({ textColor }): string => textColor};
  text-align: center;
  border-radius: 5px;
  border: 1px solid ${({ borderColor }): string => borderColor};
  display: flex;
  align-items: center;
  justify-content: center;
`

const TriangleContent = styled.div<{ bgColor: string; big?: boolean }>`
  content: '';
  display: block;
  width: 0;
  height: 0;
  position: absolute;
  left: 50%;
  bottom: ${({ big }): string => (big ? '-14px' : '-12px')};
  transform: translateX(-50%);
  border-width: ${({ big }): string => (big ? '6px 6px 9px 6px' : '5px 5px 7.5px 5px')};
  border-style: solid;
  border-color: ${({ bgColor }): string => bgColor} transparent transparent transparent;
`

const TriangleBorderContent = styled.div<{ borderColor: string; big?: boolean }>`
  content: '';
  display: block;
  width: 0;
  height: 0;
  position: absolute;
  left: 50%;
  bottom: ${({ big }): string => (big ? '-15px' : '-13px')};
  transform: translateX(-50%);
  border-width: ${({ big }): string => (big ? '6px 6px 9px 6px' : '5px 5px 7.5px 5px')};
  border-style: solid;
  border-color: ${({ borderColor }): string => borderColor} transparent transparent transparent;
`

interface ILocationPinProps {
  bgColor?: string
  borderColor?: string
  textColor?: string
  big?: boolean
  children: ReactNode
  focused?: boolean
}

export const LocationPin = ({
  bgColor = '#fff',
  borderColor = '#393939',
  textColor = '#393939',
  big = false,
  focused = false,
  children
}: ILocationPinProps): ReactElement => {
  return (
    <Container bgColor={bgColor} borderColor={borderColor} textColor={textColor} big={big} focused={focused}>
      {children}
      <span>
        <TriangleBorderContent borderColor={borderColor} big={big} />
      </span>
      <TriangleContent bgColor={bgColor} big={big} />
    </Container>
  )
}
